export default "__VITE_ASSET__DCW09O$8__"